import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    color: ${props => (props.primary ? 'red' : 'green')};
    font-size: 32px;
  }
`;
